// Polyfill
import '@expo/match-media';
import { useMediaQuery } from 'react-responsive';
import queries from 'kb-shared/theme/queries';

export function useBreakpoints() {
  const isDesktop = useMediaQuery({
    query: queries.desktop
  });

  const isMobile = useMediaQuery({
    query: queries.mobile
  });

  const isTablet = useMediaQuery({
    query: queries.tablet
  });

  return {
    isDesktop,
    isMobile,
    isTablet
  };
}
